import { SelectOption } from 'src/components'
import { regionsWithName, Region } from './schema'
import SelectWithLabel from 'src/components/Shared/UIComponents/Select'
import { ReactNode } from 'react'

const regionOptions: Array<SelectOption<Region>> = (
  Object.keys(regionsWithName) as Region[]
).map((region) => ({
  key: region,
  name: regionsWithName[region],
}))

type Props = {
  title: string
  value: Region
  onChange: (region: Region) => void
  className?: string
  placeholder?: string
  tooltip?: ReactNode
}

export function RegionSelect(props: Props) {
  return (
    <SelectWithLabel
      className={props.className}
      tooltip={props.tooltip}
      options={regionOptions}
      placeholder={props.placeholder}
      onChange={props.onChange}
      title={props.title}
      value={props.value}
    />
  )
}
